export default "__VITE_ASSET__gEanimgE__"